<template>
    <section>
        <div id="related-item" v-if="relatedItem" class="modal-mask" key="relatedItem">
            <div class="modal-wrapper _modalWrapper_">
                <div class="modal-container flexContainer">
                    <img src="../../assets/croix.png" width="20" height="20" alt="" @click="close();" class="cross fright abs pointer" />
                    <div class="modalBody">
                        <div id="selectContainer">
                            <div id="filterCategory">
                                <input id="showCategories" type="checkbox" v-model="checkCategory" @change="enableCategories();" />
                                <label class="ff-medium uppercase" for="showCategories">{{ $t("related.showOnly") }}</label>
                            </div>
                            <Multiselect
                                class="uppercase"
                                id="addRelatedItem"
                                v-model="value"
                                :options="options"
                                :multiple="true"
                                :preserve-search="true"
                                :placeholder="$t('related.search')"
                                label="name"
                                track-by="name"
                                exact
                            ></Multiselect>
                        </div>
                        <div class="flexContainer jc-sb">
                            <button @click="close();" class="btn uppercase pointer ff-light">{{ $t("common.cancel") }}</button>
                            <button class="btn uppercase pointer ff-light" @click="saveRelatedItem();">{{ $t("common.save") }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import "whatwg-fetch";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import { setUser } from "../../directives/setUser.js";
import httpService from "../../components/service";
import cacheService from "@/services/cache";

export default {
    data() {
        return {
            brandList: [],
            showModal: true,
            swiperOption: {
                direction: "horizontal",
                loop: false,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: false,
                pagination: ".swiper-pagination",
                prevButton: ".swiper-button-prev",
                nextButton: ".swiper-button-next",
                paginationClickable: true,
                mousewheelControl: true,
                observeParents: true,
                debugger: true,
                slidesPerView: 1
            },
            camp: [],
            value: [],
            options: [],
            checkCategory: true,
            product: {},
            module: {},
            allRelatedItems: {},
            apiUrl: "/components/related/" + this.$route.params.id + "?bycategory=true"
        };
    },
    components: {
        Multiselect
    },
    directives: {
        setUser
    },
    props: {
        relatedItem: {
            type: Boolean,
            requiered: true
        },
        itemType: {
            type: String,
            requiered: true
        }
    },
    watch: {
        "$route.params.id"(newId, oldId) {
            this.$store.dispatch("items/getRelatedProducts", { id: this.$route.params.id }).then(() => {
                this.updateRelatedProduct();
            });
            this.$store.dispatch("items/getRelatedModules", { id: this.$route.params.id });
        }
    },
    methods: {
        close() {
            this.$emit("closeModal", false);
            this.$emit("resetOption", "null");
        },
        saveRelatedItem() {
            let related = [];
            for (let i = 0; i < this.value.length; i++) {
                related.push(this.value[i].id);
            }
            let objectRelated = { components: related, type: this.itemType.name === "product" ? "product" : "module" };
            httpService.put("/components/related/" + this.$route.params.id, JSON.stringify(objectRelated)).then(function(response) {
                if (response === "components related is ok") {
                    location.reload();
                }
            });
        },
        async enableCategories() {
            if (this.checkCategory === true) {
                this.apiUrl = "/components/related/" + this.$route.params.id + "?bycategory=true";
                this.$forceUpdate();
            } else if (this.checkCategory === false) {
                this.apiUrl = "/components/related/" + this.$route.params.id;
                this.$forceUpdate();
            }
            const response = await httpService.get(this.apiUrl);
            let option = [];
            this.options = [];
            for (let items of response.data) {
                if (Object.values(items.infoCategories.subCategories)[0] !== "graphic holders") {
                    option[items.id] = this.getTranslate(items.terms.name);
                }
            }
            for (let j = 0; j < option.length; j++) {
                if (option[j] !== undefined) {
                    // ??
                    this.options[j] = { id: j, name: option[j] };
                }
            }
            this.$forceUpdate();
        },
        updateRelatedProduct() {
            this.product = this.getRelatedProducts;
        },
        async relatedItems() {
            const response = await httpService.get("/components/related/" + this.$route.params.id + "?bycategory=true");
            this.options = [];
            for (const index in response.data) {
                const item = response.data[index];
                this.options.push({ id: item.id, name: this.getTranslate(item.terms.name) });
            }
            this.$forceUpdate();
        }
    },
    computed: {
        ...mapGetters({
            getRelatedProducts: "items/getRelatedProducts",
            getRelatedModules: "items/getRelatedModules",
            getRelatedItems: "items/getRelatedItems"
        })
    },
    created() {
        this.$store.dispatch("items/getRelatedProducts", { id: this.$route.params.id }).then(() => {
            this.updateRelatedProduct();
        });
        this.$store.dispatch("items/getRelatedModules", { id: this.$route.params.id });
        this.$store.dispatch("items/getRelatedItems", { id: this.$route.params.id }).then(() => {
            this.relatedItems();
        });
        for (let i = 0; i < this.getRelatedProducts.length; i++) {
            this.value[i] = {
                id: this.getRelatedProducts[i].id,
                name: this.getRelatedProducts[i].terms.name[this.$t("trad")]["value"]
            };
        }
        for (let i = 0; i < this.getRelatedModules.length; i++) {
            this.value[i] = {
                id: this.getRelatedModules[i].id,
                name: this.getRelatedModules[i].terms.name[this.$t("trad")]["value"]
            };
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;

    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;

        .logoContainer {
            width: 880px;

            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;

                img {
                    margin: auto;
                }
            }
        }

        .modalBody {
            margin: auto;

            .brandWrap {
                padding: 5px;
            }

            p {
                font-family: Roboto;
                font-size: 18px;
            }

            .swiper-container-horizontal {
                .swiper-pagination {
                    margin-top: 10px;
                    position: initial;
                }
            }

            .swiper-button-prev {
                left: 25%;
                height: 15px;
            }

            .swiper-button-next {
                right: 25%;
                height: 15px;
            }
        }
    }
}

#zone {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}

#campaign {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}

#related-item {
    .modalBody {
        h2 {
            margin-top: 0px;
        }

        #selectContainer {
            margin-bottom: 30px;
        }

        width: 650px;
        min-height: 200px;
        @extend %second-background;
        @extend %primary-border;
        border-radius: 4px;
        padding: 30px;

        #filterCategory {
            margin-top: 30px;
            margin-bottom: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// modalRelated.vue?68433050